export const COREADMIN = "CoreAdmin";
export const SYSTEMADMIN = "SystemAdmin";
export const ADMIN = "Admin";
export const CONSULTANT = "Consultant";
export const CONTACT = "Contact";
export const CANDIDATE = "Candidate";